import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            width: '100%',
            maxWidth: 'container.xxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingX: {base: remCalc(16), '2xl': 0},
            paddingY: {base: remCalc(24), lg: remCalc(32)},
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
        },
        innerContainer: {
            width: '100%',
            flexDir: 'column',
        },
        productsContainer: {
            flexDir: {base: 'column', lg: 'row'},
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'flex-start'},
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        headerLabel: {
            paddingY: {base: remCalc(24), lg: remCalc(32)},
            paddingRight: {
                base: remCalc(16),
                md: 0,
            },
            position: 'sticky',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bundleCard: {
            flexDir: {base: 'row', lg: 'column'},
            alignItems: 'center',
            justifyContent: 'center',
            w: {base: remCalc(327), lg: remCalc(291)},
            h: {base: 'auto', lg: remCalc(344)},
            backgroundColor: 'background.default',
            borderRadius: {base: remCalc(8), lg: remCalc(16)},
            paddingX: {base: remCalc(8), lg: remCalc(16)},
            paddingY: {base: remCalc(4), lg: remCalc(24)},
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        firstBundleCard: {
            w: {base: remCalc(327), lg: remCalc(342.5)},
            h: {base: 'auto', lg: remCalc(420)},
        },
        plusIconContainer: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
        },
        plusIcon: {
            boxSize: {base: remCalc(15), lg: remCalc(25)},
        },
        productDetailsContainer: {
            flexDir: {base: 'row', lg: 'column'},
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: {base: remCalc(8), lg: remCalc(16)},
            flex: '1 0 0',
            fontWeight: 'normal',
            backgroundColor: 'background.default',
            width: {base: `calc(100% - ${remCalc(120)})`, lg: '100%'},
        },
        productDetailId: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        productDetailNameContainer: {
            w: {base: '100%', lg: '84%'},
        },
        productDetailName: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            'text-wrap': 'auto',
            textAlign: {base: 'left', lg: 'center'},
            noOfLines: {base: 2, lg: 1},
            textOverflow: 'ellipsis',
            fontWeight: 'medium',
            display: {base: '-webkit-box', lg: 'block'},
            whiteSpace: {base: 'normal', lg: 'nowrap'},
        },
        subtotalPrice: {
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            paddingY: {base: remCalc(16), lg: remCalc(0)},
            alignItems: 'center',
            fontWeight: 'medium',
            textStyle: {base: 'head-xsmall', lg: 'head-small'},
        },
        discountAndPriceContainer: {
            flexDir: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            gap: remCalc(4),
        },
        bundleDiscountLabel: {
            display: {base: 'none', lg: 'flex'},
            padding: `${remCalc(2)} ${remCalc(4)}`,
            backgroundColor: 'label.background.secondary',
            color: 'label.text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        bundleDiscountLabelMobile: {
            display: {base: 'flex', lg: 'none'},
            padding: `${remCalc(2)} ${remCalc(4)}`,
            backgroundColor: 'label.background.secondary',
            color: 'label.text.secondary',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        bundleImageContainer: {
            w: {base: remCalc(85), lg: '100%'},
            h: '100%',
            alignItems: 'center',
            justifyContent: 'center',
        },
        productTileImage: {
            h: '100%',
            objectFit: 'contain',
            borderRadius: {base: remCalc(0), lg: remCalc(16)},
        },
        bundleFreeGiftLabel: {
            backgroundColor: '#0C2340',
            color: 'white',
            padding: '6px 8px',
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
        },
        productPriceContainer: {
            flexDir: {base: 'column', lg: 'row'},
            w: {base: '100%', lg: 'auto'},
            alignItems: {base: 'flex-end', lg: 'center'},
            gap: {base: remCalc(5), lg: remCalc(10)},
        },
        productDetailPrice: {
            textStyle: 'body-xlarge',
            color: 'text.default',
            fontWeight: 'normal',
            order: 2,
            marginLeft: remCalc(6),
        },
        productListPrice: {
            textStyle: 'body-large',
            color: 'text.secondary',
            fontWeight: 'normal',
            order: 1,
        },
        addCartButtonContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            justifyContent: 'flex-end',
            paddingTop: {base: remCalc(0), lg: remCalc(40)},
        },
        divider: {
            display: {base: 'block', lg: 'none'},
            w: '100%',
            color: 'border.light',
        },
        addCartButton: {
            w: {base: '100%', lg: remCalc(213)},
        },
        cartBundleContainer: {
            display: 'flex',
            width: '100%',
            padding: `${remCalc(40)} ${remCalc(0)}`,
            alignItems: 'flex-start',
            gap: remCalc(24),
            borderRadius: remCalc(0),
            borderBottom: '1px solid border.neutral.subtle',

            /*             w: 'auto',
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            minWidth: {base: remCalc(150), lg: remCalc(476)},
            border: '2px solid #D4D4D4',
            borderRadius: 'medium.lg', */
        },
        cartBundleImage: {
            display: 'flex',
            width: remCalc(200),
            height: remCalc(200),
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            flexShrink: 0,
            aspectRatio: '1 / 1',
            borderRadius: 'large-1',
            background: 'url(<path-to-image>) lightgray 50% / cover no-repeat',
        },
        cartBundleContent: {
            display: 'flex',
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            flex: '1 0 0',
        },
        cartHeaderContainer: {
            display: 'flex',
            padding: remCalc(0),
            alignItems: 'center',
            gap: remCalc(0),
            alignSelf: 'stretch',
            /*             backgroundColor: 'background.light',
            w: '100%',
            padding: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            display: 'flex',
            justifyContent: 'space-between', */
        },
        cartTitleContainer: {
            display: 'flex',
            padding: `${remCalc(16)} 0`,
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        cartBundleNameContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(20),
            flex: '1 0 0',
        },
        cartBundlePriceContainer: {
            display: 'flex',
            width: remCalc(306),
            padding: remCalc(0),
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: remCalc(4),
        },
        cartBundlePriceRow: {
            display: 'flex',
            padding: remCalc(0),
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: remCalc(4),
            alignSelf: 'stretch',
        },
        cartProductSection: {
            display: 'flex',
            paddingY: remCalc(16),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        cartProductSectionContainer: {
            display: 'flex',
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(20),
            alignSelf: 'stretch',
        },
        cartProductSectionTitle: {
            flex: '1 0 0',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        cartHeaderInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
        },
        cartHeaderPriceContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
        },
        cartBundleName: {
            color: 'foreground.neutral.default',
            textStyle: 'body-xxlarge',
            fontWeight: 'medium',
            fontFamily: 'heading',
        },
        cartBundleItemContainer: {
            w: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            gap: {base: remCalc(24), lg: remCalc(26)},
            bg: 'background.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingBottom: {base: remCalc(20), lg: 0},
            paddingRight: remCalc(8),
        },
        cartBundleItemImage: {
            width: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            height: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
        },
        cartItemDetailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        cartItemHeaderStack: {
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
        },
        cartItemOmniAndPrice: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: remCalc(8),
            flexWrap: 'wrap',
        },
        cartItemVatDetails: {
            display: 'flex',
            width: {
                lg: remCalc(164),
                md: remCalc(164),
            },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(10),
        },
        cartItemName: {
            flex: '1 0 0',
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
        },
        cartItemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        cartSuggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        cartSuggestedText: {
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xsmall.base',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
        flexibleBundleContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(32),
            width: '100%',
        },
        primaryProductSection: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        inThisBundleTitle: {
            color: 'foreground.neutral.default',
            textStyle: 'body-medium',
            fontWeight: 'medium',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
        },
        primaryProductContainer: {
            display: 'flex',
            padding: '0',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
        },
        primaryProductCard: {
            display: 'flex',
            width: '100%',
            paddingY: remCalc(16),
            alignItems: 'center',
            gap: remCalc(8),
            borderRadius: remCalc(12),
            background: 'background.base.elevated',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
        primaryProductContent: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
            flex: '1 0 0',
            alignSelf: 'stretch',
        },
        imageWrapper: {
            display: 'flex',
            width: remCalc(72),
            height: remCalc(72),
            padding: '0',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '0',
            borderRadius: remCalc(4),
        },
        primaryProductInfo: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(6),
        },
        primaryProductNameContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(2),
        },
        energyLabelContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'xxsmall-1',
        },
        productName: {
            alignSelf: 'stretch',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        productImage: {
            display: 'flex',
            width: remCalc(72),
            height: remCalc(72),
            padding: '0',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '0',
            borderRadius: remCalc(4),
            background:
                'linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.03) 100%), url(<path-to-image>) lightgray 50% / contain no-repeat',
            mixBlendMode: 'multiply',
        },
        productSubtitle: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        primaryProductSubtitleContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: remCalc(4),
            alignSelf: 'stretch',
        },
        colorSwatch: {
            display: 'flex',
            width: remCalc(8),
            height: remCalc(12),
            justifyContent: 'space-between',
            alignItems: 'center',
            aspectRatio: '2/3',
            borderRadius: 'full',
            border: '1px solid background.base.default',
        },
        colorSwatchWrapper: {
            display: 'flex',
            width: remCalc(8),
            height: remCalc(12),
            justifyContent: 'space-between',
            alignItems: 'center',
            aspectRatio: '2/3',
            position: 'relative',
            top: remCalc(1),
        },
        optionalProductsSection: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            alignSelf: 'stretch',
        },
        accessoriesTitle: {
            color: 'foreground.neutral.default',
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        optionalProductsOutterContainer: {
            display: 'flex',
            width: '100%',
            maxWidth: remCalc(663),
            padding: '0',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '0',
            borderRadius: remCalc(12),
            background: 'background.base.under',
        },
        optionalProductsOutterContainerSelected: {
            background: 'background.base.elevated',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
        optionalProductsInnerContainer: {
            display: 'flex',
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            alignSelf: 'stretch',
        },
        optionalProductsHeader: {
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: {base: 'stretch', lg: 'flex-start'},
            justifyContent: {base: 'flex-start', lg: 'center'},
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        optionalProductsHeaderSelected: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
        },
        optionalProductsHeaderContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(2),
            flex: '1 0 0',
        },
        optionalProductsHeaderAction: {
            width: {base: '100%', lg: 'auto'},
            display: 'flex',
            justifyContent: {base: 'stretch', lg: 'flex-end'},
        },
        optionalProductsHeaderActionSelected: {
            width: 'auto',
            alignSelf: 'flex-start',
            justifyContent: 'flex-end',
        },
        optionalProductsHeaderActionButton: {
            width: {base: '100%', lg: 'auto'},
            borderRadius: remCalc(8),
        },
        optionalProductsHeaderActionButtonSelected: {
            width: 'auto',
        },
        selectAccessoriesTitle: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        selectedAccessoriesCount: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        accessoryTileContainer: {
            display: 'flex',
            py: remCalc(12),
            px: remCalc(0),
            alignItems: 'center',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        accessoryTileLeftBlock: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
            flex: ' 1 0 0',
            alignSelf: 'stretch',
        },
        accessoryImageWrapper: {
            display: 'flex',
            width: remCalc(62),
            height: remCalc(62),
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            borderRadius: remCalc(0),
        },
        accessoryImage: {
            display: 'flex',
            width: remCalc(62),
            height: remCalc(62),
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            borderRadius: remCalc(0),
            background:
                'linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.03) 100%), url(<path-to-image>) lightgray 50% / contain no-repeat',
            mixBlendMode: 'multiply',
        },
        accessoryInfoBlock: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(6),
            flex: '1 1 0',
            minWidth: 0,
        },
        accessoryInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(2),
            width: '100%',
        },
        accessoryName: {
            alignSelf: 'stretch',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
            noOfLines: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        accessorySubtitle: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        accessoryPrice: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        accessoryAddButton: {
            display: 'inline-flex',
            height: remCalc(36),
            paddingY: remCalc(12),
            paddingX: remCalc(16),
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(6),
            borderRadius: 'large',
            background: 'background.base.over',
            boxShadow: `0 0 0 ${remCalc(
                1,
            )} var(--chakra-colors-border-neutral-highlight) inset, 0 ${remCalc(1)} ${remCalc(
                2,
            )} 0 var(--chakra-shadows-neutral-xs), 0 0 0 ${remCalc(
                1,
            )} var(--chakra-shadows-neutral-xs) !important`,
        },
        confirmedAccessoriesListContainer: {
            display: 'flex',
            paddingY: remCalc(4),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            alignSelf: 'stretch',
        },
        confirmedAccessoriesList: {
            display: 'flex',
            width: '100%',
            paddingTop: remCalc(12),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        bundleProductRow: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        bundleProductInfoContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
            flex: '1 0 0',
            alignSelf: 'stretch',
        },
        bundleProductPriceContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            alignSelf: 'stretch',
            justifyContent: 'center',
        },
        bundleProductImageContainer: {
            display: 'flex',
            width: remCalc(38),
            padding: remCalc(0),
            alignItems: 'center',
            gap: remCalc(0),
            alignSelf: 'stretch',
            aspectRatio: '1 / 1',
        },
        bundleProductImage: {
            display: 'flex',
            width: remCalc(38),
            height: remCalc(38),
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            borderRadius: remCalc(0),
            background:
                'linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.03) 100%), url(<path-to-image>) lightgray 50% / contain no-repeat',
            mixBlendMode: 'multiply',
        },
        bundleProductInfo: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(6),
        },
        bundleProductPrice: {
            color: 'foreground.neutral.subtle',
            textAlign: 'right',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        drawerContent: {
            background: 'background.base.default',
            borderRadius: remCalc(12),
            overflow: 'hidden',
            height: '100%',
        },
        drawerHeader: {
            display: 'flex',
            padding: remCalc(24),
            alignItems: 'center',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        drawerCloseButton: {
            position: 'static',
            inset: 'auto',
            margin: 0,
            transform: 'none',
            flexShrink: 0,
            color: 'foreground.neutral.default',
        },
        drawerTitle: {
            display: 'flex',
            padding: remCalc(0),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(2),
            flex: '1 0 0',
        },
        drawerTitleText: {
            color: 'foreground.neutral.default',
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        drawerBody: {
            display: 'flex',
            padding: `${remCalc(0)} ${remCalc(24)}`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        drawerFooterButton: {
            borderRadius: 'large-1',
            display: 'flex',
            width: remCalc(218.5),
            height: remCalc(44),
            paddingY: remCalc(12),
            paddingX: remCalc(24),
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(6),
        },
        linkButton: {
            display: 'flex',
            width: remCalc(218.5),
            height: remCalc(44),
            paddingY: remCalc(12),
            paddingX: remCalc(24),
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(6),
        },
        progressTrack: {
            position: 'relative',
            display: 'flex',
            width: '100%',
            minH: remCalc(28),
            p: remCalc(8),
            alignItems: 'center',
            gap: remCalc(8),
            borderRadius: remCalc(8),
            overflow: 'hidden',
        },

        progressTrackByState: {
            empty: {
                border: `${remCalc(1)} dashed var(--border-neutral-strong, #C8C7C7)`,
                bg: 'background.base.under',
            },
            partial: {
                border: `${remCalc(1)} solid background.base.under`,
                bg: 'background.base.under',
                boxShadow: `0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))`,
            },
            complete: {
                border: `${remCalc(1)} solid border.neutral.highlight`,
                bg: 'background.base.under',
                boxShadow: `0 0 0 1px var(--accent-lg, rgba(0, 23, 135, 0.24)), 0 4px 8px 0 var(--accent-xs, rgba(0, 23, 135, 0.08)), 0 6px 23px 0 var(--accent-xs, rgba(0, 23, 135, 0.08))`,
            },
        },

        progressFill: {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            zIndex: 0,
            boxSizing: 'border-box',
            transition: 'width 0.25s ease',
        },

        progressFillByState: {
            empty: {
                bg: 'transparent',
            },
            partial: {
                bg: 'background.accent.hover',
                borderLeft: `${remCalc(1)} solid var(--border-neutral-highlight, #FFF)`,
                borderTop: `${remCalc(1)} solid var(--border-neutral-highlight, #FFF)`,
                borderBottom: `${remCalc(1)} solid var(--border-neutral-highlight, #FFF)`,
                borderTopLeftRadius: remCalc(8),
                borderBottomLeftRadius: remCalc(8),
            },
            complete: {
                bg: '#1754CC',
                borderRadius: 'inherit',
                boxShadow: `0 0 0 ${remCalc(1)} var(--border-neutral-highlight, #FFF) inset`,
            },
        },

        progressContent: {
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
        },

        progressIcon: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            w: remCalc(12),
            h: remCalc(12),
            aspectRatio: '1 / 1',
        },

        progressText: {
            textStyle: 'body-xxsmall',
            textTransform: 'uppercase',
            fontWeight: 'bold',
        },

        progressTextByState: {
            empty: {
                color: 'foreground.neutral.default',
            },
            partial: {
                color: 'foreground.neutral.inverse',
            },
            complete: {
                color: 'foreground.neutral.inverse',
            },
        },
        fixedBundlesStack: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        fixedBundlesTitle: {
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            textStyle: 'body-medium',
        },
        fixedBundlesContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        optionCard: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            padding: remCalc(0),
            alignSelf: 'stretch',
            borderRadius: remCalc(12),
            background: 'background.base.under',
        },
        optionCardSelected: {
            backgroundColor: 'background.base.elevated',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
        },
        optionCardHeader: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            padding: remCalc(16),
            justifyContent: 'space-between',
        },
        optionCardHeaderContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '2px',
            flex: '1 0 0',
        },
        optionCardHeaderTitle: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
        },
        optionCardHeaderSubtitle: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        optionCardContent: {
            display: 'flex',
            padding: ` ${remCalc(4)} ${remCalc(16)}`,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        optionCardFooter: {
            display: 'flex',
            padding: remCalc(16),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(0),
            alignSelf: 'stretch',
        },
        optionCardFooterContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            color: 'foreground.neutral.subtle',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        optionCardFooterPrice: {
            color: 'foreground.neutral.default',
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
        },
        optionBadgeContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            flexShrink: 0,
        },
    },
}
